module.exports = __webpack_public_path__ + "static/img/security-icon3.f0a74a2a.png";